import { resolveColorFillCss } from './colorFillUtils';

function shadowCss(offsetX, offsetY, blur, colorFill, fallback = 'rgba(0,0,0,0.35)') {
  const c = resolveColorFillCss(colorFill, fallback);
  const x = Number(offsetX) || 0;
  const y = Number(offsetY) ?? 4;
  const b = Math.max(0, Number(blur) ?? 12);
  return `${x}px ${y}px ${b}px ${c}`;
}

/** Classes + variables CSS pour contour / ombre au survol (bloc texte). */
export function buildTextEffectPresentation(props) {
  const p = props || {};
  const classes = ['web-creator-rich-text'];
  const style = {};

  const outlineOn = p.textOutlineEnabled === true;
  const hoverShadowOn = p.textHoverShadowEnabled === true;

  if (outlineOn) {
    classes.push('wc-text-fx-outline');
    const w = Math.max(0.5, Math.min(6, Number(p.textOutlineWidth) || 1));
    style['--wc-text-outline-width'] = `${w}px`;
    style['--wc-text-outline-color'] = resolveColorFillCss(
      p.textOutlineColor,
      '#1e293b',
    );
  }

  if (hoverShadowOn) {
    classes.push('wc-text-fx-hover-shadow');
    style['--wc-text-hover-shadow'] = shadowCss(
      p.textHoverShadowOffsetX,
      p.textHoverShadowOffsetY,
      p.textHoverShadowBlur,
      p.textHoverShadowColor,
    );
  }

  if (p.textShadowEnabled === true) {
    classes.push('wc-text-fx-shadow');
    style['--wc-text-shadow'] = shadowCss(
      p.textShadowOffsetX,
      p.textShadowOffsetY,
      p.textShadowBlur,
      p.textShadowColor,
      'rgba(0,0,0,0.2)',
    );
  }

  return { className: classes.join(' '), style };
}
